import $ from "jquery";
import mqtt from "mqtt";

const TOPIC_SHOWCONTROL_SIMULATE = "showcontrol-simulate";
const TOPIC_CONSOLE = "console";

const topics = [
  "aicontrol",
  "cbms",
  "aria",
  "tangiblevalue"
]

export class MainApp {
  constructor(options) {
    this.options = {
      'MQTT_HOST': "",
      'MQTT_PORT': "",
      'MQTT_PROTOCOL': "",
      ...options
    };
    console.log(this.options)
    this.client = null;
    this.initMQTT();
    this.initTriggers();
  }

  initTriggers() {

    $("button.trigger").on("click", (e) => {
      // Simulate Show Control Message event
      if ($(e.currentTarget).data("show-control")) {
        this.sendSimulatedShowControlMessage($(e.currentTarget).data("show-control"))
      }

      // Simulate app message
      if ($(e.currentTarget).data("app-message")) {
        const message = $(e.currentTarget).data("app-message");
        const topic = $(e.currentTarget).data("topic")
        this.client.publish(topic, message);
      }
    })

  }

  initMQTT() {

    const client = mqtt.connect(`${this.options.MQTT_PROTOCOL}://${this.options.MQTT_HOST}:${this.options.MQTT_PORT}`, {
      clientId: 'mqttjs_' + Math.random().toString(16).substr(2, 8),
    });

    client.on("connect", () => {
      client.subscribe([TOPIC_CONSOLE, "showcontrol-simulate", ...topics]);
      this.client = client;
    });

    client.on("message", (topic, message) => {
      const messageString = message.toString();

      // Update connected client labels
      if (topic === TOPIC_CONSOLE) {
        const messageData = JSON.parse(messageString);
        for (const topic of topics) {
          if (messageData[topic]) $(`.panel[data-topic='${topic}'] .connected span`).text(messageData[topic].length);
        }
      }

      // Add to message log
      if (topics.includes(topic)) {
        const currentLogs = $(`.panel[data-topic='${topic}'] .logs`).html();
        const timeString = new Date().toLocaleString();
        const newContent = (timeString + " - " + messageString + "\n" + currentLogs.substring(0, 4096));
        $(`.panel[data-topic='${topic}'] .logs`).html(newContent);

      }

    });
  }

  // Publish message to every one
  sendSimulatedShowControlMessage(message) {
    if (this.client === null) return;
    // console.log("Sending...", TOPIC_SHOWCONTROL_SIMULATE, message);
    this.client.publish(TOPIC_SHOWCONTROL_SIMULATE, message);
  }

}
